  import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
  import { provideRouter, Router } from '@angular/router';
  import { providePrimeNG } from 'primeng/config';
  import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
  import Aura from '@primeuix/themes/aura';

  import { routes } from './app.routes';
  import { provideHttpClient, withInterceptors } from '@angular/common/http';
  import { authInterceptor } from './auth/interceptors/auth.interceptor';
  import { AuthService } from './auth/auth.service';
  import { getAuthToken } from './auth/helpers/auth-storage.helper';
  import { MessageService, ConfirmationService } from 'primeng/api';
  import * as Sentry from "@sentry/angular";

  export const appConfig: ApplicationConfig = {
    providers: [
      provideBrowserGlobalErrorListeners(),
      provideRouter(routes),
      provideHttpClient(
        withInterceptors([authInterceptor])
      ),
      provideAnimationsAsync(),
      providePrimeNG({
        theme: { preset: Aura, options: { darkModeSelector: '.p-dark' } },
      }),


      MessageService,
      ConfirmationService,

      {
        provide: APP_INITIALIZER,
        useFactory: (authService: AuthService) => {
          return async () => {
            const token = getAuthToken();
            console.log(token, "ini di app.config")
            if (token) {
              try {
                await authService.verifyMe(token);
              } catch (error) {
                console.error('Initial auth verification failed:', error);
                authService.logout();
              }
            }
            return Promise.resolve(true);
          };
        },
        deps: [AuthService],
        multi: true
      },

      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
      },
      {
        provide: Sentry.TraceService,
        deps: [Router],
      },
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      }),


    ],


  };
